module.exports = "/images/x-exam-icon.svg?a5d1b676b3412e90322beac948d5b7ab";